// Fontawesome 5
import './shared/font-awesome';

// Module Route
import MailingRouting from './Mailing.routes';

// App Factories
const findMicroService = require('./factories/findMicroService');

// App Filters
const limitText = require('./filters/limitText');
const formatDate = require('./filters/formatDate');
const relativeDate = require('./filters/relativeDate');

// App Directive
const checkUserAvatar = require('./directive/checkUserAvatar');

const MailingModule = angular.module('MailingModule', []);

MailingModule.config(MailingRouting);

// Inject Factory To Module
findMicroService(MailingModule);

// Inject Filter To Module
limitText(MailingModule);
formatDate(MailingModule);
relativeDate(MailingModule);

// Inject Directive To Module
checkUserAvatar(MailingModule);


export default MailingModule;